import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { RatesService } from '../rates.service';

import { RateOverride } from './rate-override.model';

declare var toastr: any;
declare var alertify: any;

@Component({
    selector: 'app-rate-update-override',
    templateUrl: './rate-update-override.component.html',
    styleUrls: ['./rate-update-override.component.css']
})
export class RateUpdateOverrideComponent implements OnInit {

    rates: any; // NOTE: this is a paginated object
    page;
    active_rate: RateOverride = new RateOverride();
    sheets;
    active_sheet = null;

    @ViewChild('attachModal') attachModal;
    @ViewChild('rateDetail') rateDetail;

    constructor(
        private route: ActivatedRoute,
        private ratesService: RatesService
    ) { }

    ngOnInit() {
        this.route.paramMap.subscribe(params => {
            this.page = +params.get('page');
            this.loadRates();
        });
        this.loadRates();
        this.ratesService.getSheets().subscribe(sheets => this.sheets = sheets);
    }

    loadRates() {
        this.ratesService.getAllRateOverrides(this.page).subscribe(rates => this.rates = rates);
        this.rates = null;
    }

    saveRate() {
        let response;
        if (this.active_rate.id) {
            response = this.ratesService.updateRateOverride(this.active_rate);
        } else {
            response = this.ratesService.createRateOverride(this.active_rate);
        }
        response.subscribe(rate => {
            if (rate.id) {
                toastr.success('Rate Override Saved!');
                this.loadRates();
                this.rateDetail.close();
            } else {
                this.rateDetail.stopLoading();
            }
        });
    }

    deleteRate(rate) {
        if (rate.deleted) {
            return false;
        }

        alertify.confirm('Are you sure you want to delete this rate override ?', () => {
            this.ratesService.deleteRateOverride(rate)
            .subscribe(() => {
                toastr.success('Rate Override deleted!');
                this.loadRates();
            });
        });
    }

    newRate() {
        this.active_rate = new RateOverride();
        this.rateDetail.open();
    }

}
